import Vue from 'vue'
import NoticeBubble from './NoticeBubble.vue'

export default function (settings, appID) {
  const vueApp = new Vue({
    components: {
      NoticeBubble
    },

    data: {
      settings
    },

    render(h) {
      return h(NoticeBubble, {
        props: {
          settings
        }
      })
    }
  })
  vueApp.$mount(document.getElementById(appID))
}
